import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import type { AccountOverviewCompetitiveLandscapeState } from "../types/state";

import * as ac from "./action-creators";

const INITIAL_COMPANY_COMPETITIVE_LANDSCAPE_STATE: AccountOverviewCompetitiveLandscapeState = {
    isFetchingResults: false,
    resultsFetchError: undefined,
    isRowSelectionEnabled: false,
    results: {
        Data: [],
        TotalCount: 0,
        Filters: {},
    },
    isExcelDownloading: false,
};

const competitiveLandscapeResultsReducer = createReducer<
    AccountOverviewCompetitiveLandscapeState,
    ActionType<typeof ac>
>(INITIAL_COMPANY_COMPETITIVE_LANDSCAPE_STATE)
    .handleAction(
        ac.fetchResultsAsync.request,
        (state: AccountOverviewCompetitiveLandscapeState): AccountOverviewCompetitiveLandscapeState => ({
            ...state,
            isFetchingResults: true,
            results: {
                ...state.results,
                Data: INITIAL_COMPANY_COMPETITIVE_LANDSCAPE_STATE.results.Data,
            },
            resultsFetchError: INITIAL_COMPANY_COMPETITIVE_LANDSCAPE_STATE.resultsFetchError,
        }),
    )
    .handleAction(
        ac.fetchResultsAsync.success,
        (state: AccountOverviewCompetitiveLandscapeState, { payload }): AccountOverviewCompetitiveLandscapeState => ({
            ...state,
            isFetchingResults: false,
            results: {
                ...payload,
            },
        }),
    )
    .handleAction(
        ac.fetchResultsAsync.failure,
        (state: AccountOverviewCompetitiveLandscapeState, { payload }): AccountOverviewCompetitiveLandscapeState => ({
            ...state,
            isFetchingResults: false,
            resultsFetchError: payload,
        }),
    )
    .handleAction(
        ac.tableRowsSelectionToggledAction,
        (state: AccountOverviewCompetitiveLandscapeState, { payload }): AccountOverviewCompetitiveLandscapeState => ({
            ...state,
            isRowSelectionEnabled: payload,
        }),
    )
    .handleAction(
        ac.downloadAsExcelAsync.request,
        (state): AccountOverviewCompetitiveLandscapeState => ({
            ...state,
            isExcelDownloading: true,
        }),
    )
    .handleAction(
        ac.downloadAsExcelAsync.success,
        (state): AccountOverviewCompetitiveLandscapeState => ({
            ...state,
            isExcelDownloading: false,
        }),
    )
    .handleAction(
        ac.downloadAsExcelAsync.failure,
        (state, { payload }): AccountOverviewCompetitiveLandscapeState => ({
            ...state,
            isExcelDownloading: false,
            excelDownloadError: payload,
        }),
    );

export default competitiveLandscapeResultsReducer;
